export const addAlpha = (hex: string, opacity: number): string => {
  if (!/^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/.test(hex)) {
    throw new Error('Invalid hex color format');
  }
  if (opacity < 0 || opacity > 1) {
    throw new Error('Opacity must be between 0 and 1');
  }

  let normalizedHex = hex;
  if (hex.length === 4) {
    normalizedHex = '#' + [...hex.slice(1)].map(c => c + c).join('');
  }

  const r = parseInt(normalizedHex.slice(1, 3), 16);
  const g = parseInt(normalizedHex.slice(3, 5), 16);
  const b = parseInt(normalizedHex.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export const hexToShaderColor = (hex: string): [number, number, number, number] => {
  const cleanHex = hex.startsWith('#') ? hex.slice(1) : hex;
  if (!/^[0-9a-fA-F]{6}$|^[0-9a-fA-F]{8}$/.test(cleanHex)) {
    throw new Error(`Invalid hex color string provided: "${hex}"`);
  }

  const r = parseInt(cleanHex.substring(0, 2), 16);
  const g = parseInt(cleanHex.substring(2, 4), 16);
  const b = parseInt(cleanHex.substring(4, 6), 16);

  let a = 255; // Default alpha is 255 (fully opaque)
  if (cleanHex.length === 8) {
    a = parseInt(cleanHex.substring(6, 8), 16);
  }

  return [r / 255, g / 255, b / 255, a / 255];
};
